(() => {
  const runtimeKey = '__bundleBillLoadingStabilityV1';

  const bind = (builder) => {
    if (!builder || builder.dataset.bundleBillLoadingStabilityBound === 'true') return;

    const button = builder.querySelector('[data-bundle-add-to-cart]');
    const bill = builder.querySelector('[data-bundle-bill]');
    if (!button || !bill) return;

    builder.dataset.bundleBillLoadingStabilityBound = 'true';
    let keepVisibleWhileAdding = false;

    button.addEventListener('click', () => {
      if (button.disabled) return;

      const billIsVisible = !bill.hidden && window.getComputedStyle(bill).display !== 'none';
      keepVisibleWhileAdding = billIsVisible;
    }, true);

    const observer = new MutationObserver(() => {
      const isAdding = button.disabled && button.textContent.trim().toLowerCase().startsWith('adding');

      if (keepVisibleWhileAdding && isAdding) {
        bill.hidden = false;
        bill.style.display = 'flex';
      } else if (!button.disabled) {
        keepVisibleWhileAdding = false;
      }
    });

    observer.observe(button, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });
  };

  const bindWithin = (root) => {
    if (root.matches?.('product-bundle-builder')) bind(root);
    root.querySelectorAll?.('product-bundle-builder').forEach(bind);
  };

  if (!window[runtimeKey]) {
    window[runtimeKey] = true;
    customElements.whenDefined('product-bundle-builder').then(() => bindWithin(document));
    document.addEventListener('shopify:section:load', (event) => bindWithin(event.target));
  } else {
    customElements.whenDefined('product-bundle-builder').then(() => bindWithin(document));
  }
})();
